import React from 'react'
import './Discover_Wallpaper_Banner.css'
import { Link } from 'react-router-dom'

const Discover_Wallpaper_Banner = () => {
  return (
    <section className='Discover_Wallpaper_Banner'>
      <Link to={"/gallery-frames"}>
        <div className='container'>
          <div className='banner_holder'>
            <img src='/assets/images/insight/discover_wallpaper/banner2.png' className='banner_img' />
          </div>
        </div>
      </Link>
    </section>
  )
}

export default Discover_Wallpaper_Banner
